// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__WGEcV","summary":"CartItem_summary__vP3UT","price":"CartItem_price__H+IJ+","amount":"CartItem_amount__YXlOd","actions":"CartItem_actions__6-6ud"};